import React, { useEffect, useRef } from 'react';
import {
  Box,
  FormControl,
  Menu,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { createEventId } from './event-utils';
import AnimationPage from '../../pages/AnimationPage';
import CustomCheckbox from '../CustomCheckbox';
import { useState } from 'react';
import GroupLessonEditModal from './lessonModal/GroupLessonEditModal/GroupLessonEditModal';
import { useSelector } from 'react-redux';
import { getTicketsByType } from '../../api/ticket';
import { getAllPointRooms } from '../../api/point';
import {
  addMinutesToTime,
  copyToNextWeek,
  errorMessages,
  getAllLessonEvents,
  getCalendarWeekRange,
  toTop,
} from '../../utils/methods';
import { deleteWeekById, getAllLessonsByType } from '../../api/lesson';
import { getPointTrainers } from '../../api/staff';
import { getLessonById } from '../../api/lesson';
import { useTranslation } from 'react-i18next';
import { useToast } from 'use-toast-mui';
import QueryString from 'qs';
import moment from 'moment';
import { Divider, Tab, Tabs } from '@mui/material';
import PrivateLessonList from './privateLesson/PrivateLessonList';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '606px',
  height: '890px',
  bgcolor: '#fff',
  borderRadius: '10px',
  border: 'none',
};

function createData(checkbox, name, calories, fat, carbs) {
  return { checkbox, name, calories, fat, carbs };
}

const rows = [
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
  createData(<CustomCheckbox />, '홍길동', '01097791122', '2022.11.15(목) 오전 11:05', '예약'),
];

const headerContent = (e, lang) => {
  const day =
    lang === 'en' ? e.text.split(' ')[1].slice(2) : e.text.slice(e.text.indexOf(' ') + 1, e.text.lastIndexOf('.'));
  const week = lang === 'en' ? e.text.split(' ')[0] : e.text.slice(e.text.indexOf('(') + 1, e.text.indexOf(')'));
  return (
    <div className="custom-date">
      <h2>{week}</h2>
      <h1>{day}</h1>
    </div>
  );
};

const renderEventContent = (setOpens, opens, eventInfo) => {
  return (
    <Box
      sx={{ borderRadius: '10px', p: '10px' }}
      id="demo-positioned-button"
      aria-controls={opens.openMenu ? 'demo-positioned-menu' : ''}
      aria-haspopup={true}
      aria-expanded={opens.openMenu}
      onClick={e => setOpens({ ...opens, openMenu: e.currentTarget })}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <b>{eventInfo.timeText}</b>
      </Box>
      <br />
      <br />
      <i>{eventInfo.event.title}</i>
    </Box>
  );
};

const OnlineLesson = () => {
  const calendarRef = useRef();
  const toast = useToast();
  const { user } = useSelector(state => state.user);
  const { t } = useTranslation();
  const { mainLang } = useSelector(state => state.lang);
  const [dateRange, setDateRange] = useState();
  const [calenderObj, setCalendarObj] = useState();
  const [clickInfo, setClickInfo] = useState();
  const [allEvents, setAllEvents] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const [active, setActive] = useState();
  const [lesson, setLesson] = useState();
  const [selectedTabChild, setSelectedTabChild] = useState(2);

  const [lessonData, setLessonData] = useState({
    name: '',
    periodStart: '',
    periodEnd: '',
    type: 2,
  });
  const [opens, setOpens] = useState({
    update: true,
    open: false,
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
    openMenu: false,
    openMenu1: false,
    trainers: [],
    trainerId: null,
    busyDates: [],
  });

  const handleCloseMenu = () => {
    setOpens({ ...opens, openMenu: false });
  };
  const handleClickMenu1 = event => {
    setOpens({ ...opens, openMenu1: event.currentTarget });
  };
  const handleCloseMenu1 = () => {
    setOpens({ ...opens, openMenu1: false, openMenu: false });
  };

  const deleteWeek = async () => {
    const eventData = anchorEl?.extendedProps?.eventData;
    deleteWeekById(anchorEl.extendedProps.eventData.courseClassTimeId, user.token)
      .then(() => {
        setOpens({
          update: false,
          open: false,
          open1: false,
          open2: false,
          open3: false,
          open4: false,
          open5: false,
          openMenu: false,
          openMenu1: false,
        });
        setAllEvents(allEvents.filter(event => event?.courseClassTimeId !== eventData?.courseClassTimeId));
        getLessons();
      })
      .catch(err => {
        console.log(err);
        toast.error(errorMessages(err));
      });
  };

  const handleOpen = e => {
    setCalendarObj(e);
    const day = new Date(e.start).getDay();
    setLessonData({
      ...lessonData,
      periodStart: e.startStr.split('T')[0],
      currentDayInfo: {
        timeStart: e.startStr.split('T')[1].split('+')[0],
        timeEnd: addMinutesToTime(e.startStr.split('T')[1].split('+')[0]),
        week: day,
      },
    });
    setOpens({ ...opens, open: true });
  };

  const handleOpen1 = e => {
    setClickInfo(e);
    setOpens({ ...opens, open1: true });
  };

  const handleClose1 = () => {
    setOpens({ ...opens, open1: false });
  };

  const handleDateSelect = () => {
    let calendarApi = calenderObj.view.calendar;
    calendarApi.unselect();
    if (lessonData.name) {
      calendarApi.addEvent({
        id: createEventId(),
        title: lessonData.name,
        start: calenderObj.startStr,
        end: calenderObj.endStr,
        allDay: calenderObj.allDay,
        backgroundColor: '#0F7F85',
      });
    }
  };
  const handleEventClick = () => {
    clickInfo.event.remove();
    setOpens({ ...opens, open1: false });
  };

  const setRooms = e => {
    const id = e.target.value;
    setOpens({ ...opens, roomId: id });
  };

  async function fetchData() {
    const queryString = QueryString.stringify({
      // trainerId: opens.trainerId,
      branchId: user.branch.branchId,
      courseClassType: 'ONLINE_LESSON',
    });
    const tickets = await getTicketsByType(queryString, user.token);
    const trainers = await getPointTrainers(user.branch.branchId, user.token);
    const rooms = await getAllPointRooms(user.branch.branchId, user.token);

    setLessonData({
      ...lessonData,
      tickets: tickets,
      trainers: trainers,
      rooms: rooms,
    });
  }
  const getLesson = async () => {
    try {
      const data = await getLessonById(anchorEl?.extendedProps.eventData.courseClassId, user.token);
      setLesson(data);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };
  const getLessons = async () => {
    if (dateRange && user.branch) {
      try {
        const query = {
          courseClassType: 'ONLINE_LESSON',
          headBranchId: user.headBranch.headBranchId,
          branchId: user.branch?.branchId,
          // trainerId: opens.trainerId,
          branchExerciseRoomId: opens.roomId,
          classDateFrom: dateRange.start,
          classDateTo: dateRange.end,
        };
        const queryString = QueryString.stringify(query);
        const data = await getAllLessonsByType(queryString, user.token);
        // const trainers = data.filter((obj, index, array) => {
        //   return array.findIndex(item => item.trainerId === obj.trainerId) === index;
        // });
        setOpens({ ...opens, lessons: data, update: false });
        setAllEvents(getAllLessonEvents(data));
      } catch (error) {
        toast.error(errorMessages(error));
      }
    }
  };

  const handleChange = (e, newValue) => {
    setSelectedTabChild(newValue);
  };

  useEffect(() => {
    if (calendarRef.current) {
      const start = getCalendarWeekRange(calendarRef.current).start;
      const end = getCalendarWeekRange(calendarRef.current).end;
      setDateRange({ start: start, end: end });
    }
    toTop();
  }, []);

  useEffect(() => {
    getLessons();
  }, [opens.roomId]);
  useEffect(() => {
    getLessons();
  }, [dateRange, user]);

  useEffect(() => {
    if (user.branch?.branchId) {
      fetchData();
    }
  }, [user, opens.roomId]);
  useEffect(() => {
    if (anchorEl) {
      getLesson();
    }
  }, [anchorEl]);
  if (!user.branch?.branchId) {
    return t('Please select a point');
  }
  return (
    <AnimationPage>
      <Tabs
        sx={{
          minHeight: '40px',
          ml: 5,
          '& .MuiTab-root.MuiTab-textColorSecondary': {
            borderRadius: '12px',
            border: '1px solid #0F7F85',
            mr: 1.25,
            minWidth: '100px',
            minHeight: '40px !important',
            padding: '12px 40px',
            fontWeight: 500,
            fontSize: '13px',
          },
          '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
            background: '#0F7F85',
            borderRadius: '12px',
            border: 'none',
            color: '#fff',
          },
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-textColorSecondary.css-sopws0-MuiButtonBase-root-MuiTab-root': {
            borderRadius: '8px 8px 0px 0px',
            background: '#AEAEAE',
            border: 'none',
            color: '#fff',
          },
          '& .MuiTab-textColorSecondary.css-1gc9b8s-MuiButtonBase-root-MuiTab-root': {
            borderRadius: '8px 8px 0px 0px',
            background: '#AEAEAE',
            border: 'none',
            color: '#fff',
          },
          '& .MuiTab-textColorSecondary.css-sopws0-MuiButtonBase-root-MuiTab-root.Mui-selected': {
            borderRadius: '8px 8px 0px 0px',
          },
          '& .MuiTab-textColorSecondary.css-1gc9b8s-MuiButtonBase-root-MuiTab-root.Mui-selected': {
            borderRadius: '8px 8px 0px 0px',
          },
        }}
        value={selectedTabChild}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example">
        <Tab value={2} label={t('Daily View')} />
        <Tab value={1} sx={{ mb: '0px', pb: '0px' }} label={t('Weekly View')} />
      </Tabs>
      <Box
        component={Paper}
        elevation={2}
        style={{
          background: '#FFFFFF 0% 0% no-repeat padding-box',
          borderRadius: '10px',
          padding: ' 21px 40px',
          width: '100%',
          boxShadow: '0px 0px 7px #0000000D',
        }}>
        {selectedTabChild === 1 && (
          <>
            <FormControl color="info" size="small" sx={{ width: '250px' }}>
              {/* <InputLabel sx={{ fontSize: '14px', color: '#3a3a3a' }}>{t('강사를 선택해주세요')}</InputLabel>
          <Select variant="outlined" label={t('강사를 선택해주세요')} sx={{ background: '#fff' }} onChange={setRooms}>
            <MenuItem value={0}>{t('강의를 선택해주세요')}</MenuItem>
            {lessonData.rooms?.map((t, i) => (
              <MenuItem key={i} value={t.branchExerciseRoomId}>
                {t.branchExerciseRoomName}
              </MenuItem>
            ))}
          </Select> */}
            </FormControl>
            <Button
              size="large"
              sx={{
                ml: '63%',
                background: '#f1f4f6',
                color: '#707070',
                '&:hover': { background: '#f1f4f6' },
                borderRadius: '12px',
                pl: '15px',
                pr: '10px',
                minWidth: '128px',
                height: '36px',
              }}
              onClick={() => copyToNextWeek(allEvents, user.token, setOpens, opens, toast)}
              disabled={!allEvents}>
              {t('Copy Weekly Schedule')}
              <ContentCopyOutlinedIcon sx={{ ml: '5px', width: '20px', height: '16px' }} />
            </Button>
            <Box
              sx={{
                zIndex: 2,
                mt: -4,
                display: 'grid',
                gridTemplateColumns: 'auto auto',
              }}>
              <FullCalendar
                slotMinTime={'06:00:00'}
                slotMaxTime={'24:00:00'}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                ref={calendarRef}
                headerToolbar={{
                  left: `prev`,
                  center: `title`,
                  right: 'next today',
                }}
                customButtons={{
                  next: {
                    click: () => {
                      calendarRef.current.getApi().next();
                      setDateRange({
                        start: moment(calendarRef.current.getApi().view.currentStart).format('YYYY-MM-DD'),
                        end: moment(calendarRef.current.getApi().view.currentEnd).format('YYYY-MM-DD'),
                      });
                    },
                  },
                  prev: {
                    click: () => {
                      calendarRef.current.getApi().prev();
                      setDateRange({
                        start: moment(calendarRef.current.getApi().view.currentStart).format('YYYY-MM-DD'),
                        end: moment(calendarRef.current.getApi().view.currentEnd).format('YYYY-MM-DD'),
                      });
                    },
                  },
                }}
                locale={mainLang}
                allDaySlot={false}
                initialView="timeGridWeek"
                editable={false}
                dayHeaderContent={e => headerContent(e, mainLang)}
                selectable={true}
                selectMirror={true}
                dayMaxEvents={true}
                nowIndicator={true}
                eventColor="#a1a1a1"
                events={allEvents}
                select={handleOpen}
                eventContent={e => renderEventContent(setOpens, opens, e)}
                eventClick={e => setAnchorEl(e.event)}
              />
              <div className="custom-col"></div>
              <div className="custom-row"></div>
            </Box>
          </>
        )}

        {selectedTabChild === 2 && (
          <Box sx={{ width: '100%' }}>
            <PrivateLessonList courseClassType={'ONLINE_LESSON'} />
          </Box>
        )}
      </Box>

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={opens.openMenu}
        open={Boolean(opens.openMenu)}
        className="calendar-modal1"
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ ml: 2, mt: -1, borderRadius: '12px' }}>
        <Box sx={{ width: '240px', p: '16px', gap: '1' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: '5px' }}>
            <Typography
              sx={{
                fontSize: '15px',
                color: '#3a3a3a',
                letterSpacing: '-0.38px',
              }}>
              {t('수업명')}: {anchorEl?.extendedProps.eventData.className}
            </Typography>
            <MoreVertIcon
              id="demo-positioned-button1"
              aria-controls={opens.openMenu1 ? 'demo-positioned-menu1' : ''}
              aria-haspopup={true}
              aria-expanded={opens.openMenu1}
              onMouseOver={handleClickMenu1}
              sx={{
                color: '#0F7F85',
                '&:hover': {
                  bgcolor: '#ddd',
                  borderRadius: '50%',
                  cursor: 'pointer',
                },
              }}
            />
          </Box>
          <Typography>
            {anchorEl?.extendedProps.eventData.startTime}
            {' - '}
            {anchorEl?.extendedProps.eventData.endTime}
          </Typography>
          <hr style={{ border: '1px solid #e1e1e1' }} />
          <Typography sx={{ mb: '5px' }}>
            {t('강사')}: {t('강사')}: {anchorEl?.extendedProps.trainerName}
          </Typography>
          <Typography sx={{ mb: '5px' }}>
            {t('수업 정원')}: {anchorEl?.extendedProps.eventData.maxMemberCount}
          </Typography>

          <Typography>
            {t('강의실')}: {anchorEl?.extendedProps.branchExerciseRoomName}
          </Typography>
        </Box>
      </Menu>

      <Menu
        id="demo-positioned-menu1"
        aria-labelledby="demo-positioned-button1"
        anchorEl={opens.openMenu1}
        open={Boolean(opens.openMenu1)}
        className="calendar-modal2"
        onClose={handleCloseMenu1}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ transform: 'translateX(10px)', ml: 2, mt: -1, padding: '18px 0' }}>
        <MenuItem
          onClick={() => {
            handleCloseMenu1();
            handleOpen1();
          }}>
          {t('참석 관리')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCloseMenu1();
            setOpens({ ...opens, open4: true });
          }}>
          {t('수업 수정')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCloseMenu1();
            setOpens({ ...opens, open2: true });
          }}>
          {t('수업 취소')}
        </MenuItem>
      </Menu>

      <Modal open={opens.open1} onClose={handleClose1}>
        <Box sx={{ ...style }}>
          <Box
            sx={{
              backgroundColor: '#111',
              display: 'flex',
              justifyContent: 'space-between',
              height: '52px',
              p: '15px 20px',
              borderTopRightRadius: '10px',
              borderTopLeftRadius: '10px',
            }}>
            <Typography
              sx={{
                color: '#fff',
                backgroundColor: '#111',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
              {t('참석관리')}
            </Typography>
            <CloseIcon onClick={handleClose1} sx={{ color: '#fff', cursor: 'pointer' }} />
          </Box>
          <Box sx={{ p: '30px 28px 50px 28px' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
              {t('2022년 12월 20일 (금) 오후 7:00~ 오후 8:30')}
            </Typography>

            <Box sx={{ display: 'flex', pt: '30px' }}>
              <Typography sx={{ mr: '28px', fontWeight: 500 }}>{t('회원 검색')}</Typography>
              <TextField
                color="info"
                sx={{ width: '370px' }}
                required
                variant="outlined"
                size="small"
                placeholder={t('Search by your client’s name, ID, and phone number')}></TextField>
              <Button
                sx={{
                  ml: '4px',
                  background: '#707070',
                  '&:hover': { backgroundColor: '#707070' },
                }}
                variant="contained">
                {t('Search')}
              </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', pt: '16px' }}>
              <Typography sx={{ mr: '18px', fontWeight: 500 }}>{t('수강권 선택')}</Typography>
              <FormControl color="info" size="small" sx={{ width: '370px' }}>
                <Select defaultValue="0" variant="outlined" sx={{ background: '#fff' }}>
                  <MenuItem disabled value="0">
                    {t('수강권을 선택해주세요')}
                  </MenuItem>
                  <MenuItem selected value="1">
                    {t('필라테스 그룹레슨 12개월 100회')}
                  </MenuItem>
                  <MenuItem selected value="2">
                    {t('필라테스 그룹레슨 6개월 50회')}
                  </MenuItem>
                  <MenuItem selected value="3">
                    {t('필라테스 그룹레슨 12개월 100회')}
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <hr style={{ border: '1px solid #e1e1e1' }} />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                size="small"
                sx={{
                  fontSize: '13px',
                  height: '36px',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#707070' },
                  background: '#707070',
                  p: '5px 20px',
                  borderRadius: '10px',
                }}>
                {t('초기화')}
              </Button>
              <Button
                size="small"
                sx={{
                  '&:hover': { backgroundColor: '#707070' },
                  p: '5px 20px',
                  fontSize: '13px',
                  height: '36px',
                  color: '#fff',
                  background: '#707070',
                  borderRadius: '10px',
                  ml: 1,
                }}>
                {t('회원 추가')}
              </Button>
            </Box>
            <Typography sx={{ mt: '10px', fontWeight: 500 }}>{t('참석 현황')}</Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                background: '#F1F4F6',
                borderRadius: '4px',
                p: 1,
                mt: '12px',
              }}>
              <Button
                variant="outlined"
                sx={{
                  height: '36px',
                  width: '130px',
                  background: '#fff',
                  '&:hover': { backgroundColor: '#fff' },
                  borderRadius: '18px',
                  border: '1.5px solid #0F7F85',
                  color: '#0F7F85',
                  fontWeight: 500,
                  fontSize: '12px',
                }}>
                {t('예약 : 8명')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  height: '36px',
                  width: '130px',
                  '&:hover': { backgroundColor: '#0F7F85' },
                  borderRadius: '18px',
                  fontWeight: 500,
                  fontSize: '12px',
                }}>
                {t('출석: 0명')}
              </Button>
              <Button
                variant="contained"
                color="info"
                sx={{
                  height: '36px',
                  width: '130px',
                  '&:hover': { backgroundColor: '#9A9A9A' },
                  borderRadius: '18px',
                  color: '#fff',
                  fontWeight: 500,
                  fontSize: '12px',
                }}>
                {t('결석: 0명')}
              </Button>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', pt: '6px' }}>
              <TableContainer sx={{ height: '550px, width:"360px', borderRadius: '4px' }} checkboxSelection>
                <Table
                  aria-label="simple table"
                  sx={{
                    borderRadius: '5px',
                    border: '1px solid #ebebeb',

                    '.css-1krcoiz-MuiTableCell-root': { padding: '1px' },
                    '.css-am7boh-MuiTableCell-root': { padding: '1px' },
                    '.css-7tokan-MuiTableCell-root': { padding: '1px' },
                  }}>
                  <TableHead sx={{ background: '#FAFBFC' }}>
                    <TableRow sx={{ height: '40px' }}>
                      <TableCell align="center" sx={{ width: '10px', borderRight: '1px solid #ddd' }}>
                        <CustomCheckbox />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: '1px solid #ddd',
                          fontWeight: 500,
                          fontSize: '12px',
                        }}>
                        {t('회원명')}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: '1px solid #ddd',
                          fontWeight: 500,
                          fontSize: '12px',
                        }}>
                        {t('전화번호')}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          borderRight: '1px solid #ddd',
                          fontWeight: 500,
                          fontSize: '12px',
                        }}>
                        {t('예약 일시')}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 500, fontSize: '12px' }} align="center">
                        {t('상태')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (
                      <TableRow
                        key={row.name}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            borderBottom: 0,
                          },
                        }}>
                        <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                          {row.checkbox}
                        </TableCell>
                        <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }} component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                          {row.calories}
                        </TableCell>
                        <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                          {row.fat}
                        </TableCell>
                        <TableCell align="center">{row.carbs}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                mt: '20px',
              }}>
              <Button
                size="small"
                sx={{
                  width: '88px',
                  height: '36px',
                  color: '#fff',
                  font: 'normal normal normal 13px/15px Pretendard',
                  borderRadius: '10px',
                  '&:hover': { backgroundColor: '#707070' },
                  background: '#707070',
                }}>
                {t('내역 삭제')}
              </Button>
              <Button
                size="small"
                onClick={handleEventClick}
                sx={{
                  width: '88px',
                  height: '36px',
                  color: '#fff',
                  font: 'normal normal normal 13px/15px Pretendard',
                  borderRadius: '10px',
                  '&:hover': { backgroundColor: '#9a9a9a' },
                  background: '#9a9a9a',
                }}>
                {t('결석 처리')}
              </Button>
              <Button
                size="small"
                sx={{
                  backgroundColor: '#0F7F85',
                  color: '#fff',
                  font: 'normal normal normal 13px/15px Pretendard',
                  width: '88px',
                  height: '36px',
                  borderRadius: '10px',
                  '&:hover': { backgroundColor: '#0F7F85' },
                }}>
                {t('출석 처리')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={opens.open2}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '440px',
            height: '331px',
            bgcolor: '#fff',
            borderRadius: '10px',
            border: 'none',
          }}>
          <Box sx={{ p: '20px' }}>
            <CloseIcon
              sx={{ float: 'right' }}
              onClick={() => {
                setOpens({ ...opens, open2: false });
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontSize: '18px',
                  mt: '80px',
                  ml: '117px',
                  fontWeight: 600,
                }}>
                {t('수업을 취소하시겠습니까?')}
              </Typography>
              <Typography sx={{ mt: '23px', ml: '110px' }}>{t('*수업 취소 전 반드시 회원 및 강사에게')}</Typography>
              <Typography sx={{ ml: '125px' }}>{t('취소 사유를 알려주시기 바랍니다')}.</Typography>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#c5c5c5',
                  '&:hover': { backgroundColor: '#c5c5c5' },
                  mt: '53px',
                  borderRadius: '10px',
                  ml: '100px',
                }}>
                {t('돌아가기')}
              </Button>
              <Button
                variant="contained"
                size="large"
                sx={{ borderRadius: '10px', mt: '53px', ml: '10px' }}
                onClick={deleteWeek}>
                {t('수업 취소하기')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={opens.open3}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '440px',
            height: '227px',
            bgcolor: '#fff',
            borderRadius: '10px',
            border: 'none',
          }}>
          <Box>
            <Typography sx={{ fontSize: '18px', mt: '80px', ml: '117px' }}>
              {t('예약 취소를 완료하였습니다')}
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={{
                borderRadius: '10px',
                mt: '52px',
                ml: '189px',
                pl: '20px',
                pr: '15px',
              }}
              onClick={() => {
                setOpens({ ...opens, open3: false });
              }}>
              {t('확인')}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={opens?.busyDates?.length}
        onClose={() => {
          setOpens({ ...opens, busyDates: [] });
        }}
        sx={{ '& :focus-visible': { outline: 'none' } }}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            textAlign: 'center',
            transform: 'translate(-50%, -50%)',
            width: '500px',
            maxHeight: '600px',
            bgcolor: '#fff',
            borderRadius: '10px',
            border: 'none',
            overflow: 'hidden',
          }}>
          <Box
            sx={{
              backgroundColor: '#111',
              height: '52px',
              display: 'flex',
              justifyContent: 'space-between',
              borderTopRightRadius: '10px',
              borderTopLeftRadius: '10px',
              p: '17px 20px',
            }}>
            <Typography
              sx={{
                fontSize: '16px',
                color: '#fff',
              }}>
              {t('이미 있습니다')}
            </Typography>
            <CloseIcon
              onClick={() => {
                setOpens({ ...opens, busyDates: [] });
              }}
              sx={{ color: '#fff', cursor: 'pointer' }}
            />
          </Box>
          <Box sx={{ overflow: 'auto', height: '95%', padding: '20px' }}>
            {opens?.busyDates?.map((data, index) => (
              <Typography sx={{ fontSize: '18px' }} key={index}>
                <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{data.day}</span> ({data.timeStart} -{' '}
                {data.timeEnd})
              </Typography>
            ))}
          </Box>
        </Box>
      </Modal>

      {opens.open && (
        <GroupLessonEditModal
          mode="create"
          user={user}
          type="ONLINE_LESSON"
          opens={opens}
          setOpens={setOpens}
          lessonData={lessonData}
          setLessonData={setLessonData}
          onSuccess={setAllEvents}
          handleDateSelect={handleDateSelect}
        />
      )}

      {opens.open4 && (
        <GroupLessonEditModal
          mode="edit"
          user={user}
          type="ONLINE_LESSON"
          opens={opens}
          setOpens={setOpens}
          lessonData={{ ...lessonData, ...anchorEl?.extendedProps }}
          setLessonData={setLessonData}
          lesson={lesson}
          onSuccess={setAllEvents}
        />
      )}
    </AnimationPage>
  );
};

export default OnlineLesson;
